import React from 'react';
import classNames from 'classnames';
import { gettext } from '@eventbrite/legacy-infra.i18n';
import { Icon } from '@eventbrite/legacy-eds.icon';
import { TABBABLE_INDEX } from '@eventbrite/legacy-eds.hot-keys';
import { ChevronUpChunky, ChevronDownChunky } from '@eventbrite/legacy-eds.iconography';
import styles from './DropLink.module.scss';

export class DropLink extends React.PureComponent {
    componentDidUpdate() {
        const { tabIndex, shouldFocusDropLink } = this.props;
        return tabIndex === TABBABLE_INDEX && shouldFocusDropLink ? this._focus() : this._blur();
    }

    _getRef(ref) {
        this._link = ref;
        return this._link;
    }

    _blur() {
        this._link.blur();
    }

    _focus() {
        this._link.focus();
    }

    _getAriaLabel() {
        const { children, ariaLabelContent } = this.props;
        const childLabel = children?.props?.label;

        if (childLabel) {
            return childLabel;
        }

        const baseLabel = gettext('Dropdown menu').toString();
        if (!ariaLabelContent) {
            return baseLabel;
        }

        return `${baseLabel} ${gettext('with label').toString()} ${ariaLabelContent}`;
    }

    render() {
        const { children, fallbackUrl, dropUp, onClick, tabIndex, hideDropIconWhenNarrow, role } =
            this.props;
        const iconType = dropUp ? <ChevronUpChunky /> : <ChevronDownChunky />;
        const iconClassName = classNames(styles.icon, {
            [styles.iconNarrowBreakpoints]: hideDropIconWhenNarrow,
        });

        return (
            <a
                className={styles.root}
                href={fallbackUrl}
                onClick={onClick}
                data-testid="dropdown-link"
                role={role ?? 'menuitem'}
                ref={this._getRef.bind(this)}
                onMouseEnter={this._focus.bind(this)}
                onMouseLeave={this._blur.bind(this)}
                tabIndex={tabIndex}
                aria-label={this._getAriaLabel()}
            >
                <div className={styles.contents} data-testid="dropdown-link-contents">
                    {children}
                </div>
                <span className={iconClassName} data-testid="dropdown-link-icon">
                    <Icon type={iconType} color="grey-400" isBlockLevel={true} />
                </span>
            </a>
        );
    }
}
